import ValidationPage from './validationPage';

export default ValidationPage;
